import { render, staticRenderFns } from "./finishRegister.vue?vue&type=template&id=71671336&scoped=true&"
import script from "./finishRegister.vue?vue&type=script&lang=js&"
export * from "./finishRegister.vue?vue&type=script&lang=js&"
import style0 from "./finishRegister.vue?vue&type=style&index=0&id=71671336&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71671336",
  null
  
)

export default component.exports